import { Controller } from 'stimulus';

class MobileQuickFilterController extends Controller {
  static targets = ['select', 'button'];

  /**
   * Change handler for choosing the quick filter `select` option.
   * Grabs value of the newly selected quick filter and sets the `href`
   * of the 'Apply' button to this value. This allows the user to navigate
   * to the URL that matches their chosen filter.
   *
   * @returns {void}
   */
  handleChange() {
    this.buttonTarget.href =
      `/opportunities/search?${this.selectTarget.value}`;
  }
}

export default MobileQuickFilterController;
